export const OAUTH_CANCELLED = 'oauth_cancelled';

export const OAUTH_POPUP_BLOCKED =
  'Popup blocked. Please allow popups for this site.';

export const OAUTH_POPUP_TIMEOUT =
  'Authentication timeout. Please try again.';

export function isOAuthCancelled(error: unknown): boolean {
  return error === OAUTH_CANCELLED;
}

export function isOAuthPopupBlocked(message: string | undefined): boolean {
  return message === OAUTH_POPUP_BLOCKED;
}

export function getOAuthUserMessage(message: string | undefined): string {
  if (!message || message === OAUTH_CANCELLED) return '';
  if (isOAuthPopupBlocked(message)) {
    return 'Your browser blocked the sign-in popup. Allow popups for this site in your browser settings, then try again.';
  }
  if (message === OAUTH_POPUP_TIMEOUT) {
    return 'Sign-in timed out. Please try again.';
  }
  return message;
}
